import { useTranslation } from "react-i18next";
import './UserProfile.css'
import { Navigation } from "../Common/Navigation/Navigation";
import React, {useEffect, useState} from "react";
import { NavigationFooterProps } from "../Common/Navigation/NavigationFooter";
import { CatalogSelect } from "../Common/Catalog/CatalogSelect";
import { WaUser } from "../../types/farming";
import {loading, Wrapped} from "../../communication/wrapped";
import { Loading } from "../Common/Loading/LoadingPlaceholder";
import {getImageUrl, getUser, LOADED} from "../../communication/communication";
import { ApiKeyView } from "./ApiKeyView";
import { FriendsView } from "../Friends/FriendsView";
import { QRCode } from "./QRCode";

export const defaultPictureBig = <svg className="circle-image-big" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
    <rect width="64" height="64" rx="32" fill="#5E5E5E" />
    <circle cx="32.0002" cy="25.3334" r="6.66667" fill="#212121" />
    <path fillRule="evenodd" clipRule="evenodd"
        d="M22.1358 44.4136C20.4865 43.6151 19.8124 41.6158 20.8107 40.0791C23.1879 36.42 27.3112 34 31.9998 34C36.6884 34 40.8118 36.42 43.1889 40.0791C44.1872 41.6158 43.5132 43.6151 41.8638 44.4136C38.8817 45.8572 35.5353 46.6667 31.9998 46.6667C28.4644 46.6667 25.118 45.8572 22.1358 44.4136Z"
        fill="#212121" />
</svg>


export type UserProfileProps = {
    user: Wrapped<WaUser>,
    reloadUser: () => void
}

function UserProfileLoading(props: UserProfileProps) {
    const userDisplay = <div className="flex-row small-gap small-margin small-margin-top" style={{ height: "5rem" }}>
        {defaultPictureBig}
        <div className="flex-y-center">
            <span className="font-white fw-500 big-font"> <Loading className={"full-size"} /> </span>
        </div>
    </div>

    return <div className="full-size bg-black user-profile-edit">
        {userDisplay}
        <div>
        </div>
    </div>
}

export function UserProfile() {
    const { t } = useTranslation()
    const [userRaw, setUserRaw] = useState(loading<WaUser>(null!));

    useEffect(() => {
        getUser().then(setUserRaw);
    }, []);

    if (userRaw.statusCode !== LOADED) {
        return <UserProfileLoading user={userRaw} reloadUser={() => {getUser().then(setUserRaw)}} />
    }

    const user = userRaw.data!;

    const displayedUserName = user.first_name ? `${user.first_name} ${user.last_name}` : user.username ?? t("guest")

    const photoUrl = user.photo_url;
    const photo = photoUrl
        ? <img className="circle-image-big" src={getImageUrl(photoUrl)} alt="" />
        : defaultPictureBig;

    const userDisplay = <div className="flex-row small-gap small-margin small-margin-top" style={{ height: "5rem" }}>
        {photo}
        <div className="flex-y-center">
            <span className="font-white fw-500 big-font"> {displayedUserName} </span>
        </div>
    </div>

    const navigation = (p: NavigationFooterProps) => <CatalogSelect
        navigationFooterProps={p}
        categories={[{ id: "Key", text: t("apiKey") }, { id: "Friends", text: t("friends") }, { id: "QR", text: "QR" }]}
        includeAll={false}
    />;

    const mainContent = <Navigation
        screens={[<ApiKeyView />, <FriendsView />, <QRCode />]}
        navigation={navigation}
        orientation={"up"}
        useGestures={false}
        isMain={false}
        navigationStackHeight={"calc(var(--app-height) - 9rem)"}
    />

    return <div className="full-size bg-black user-profile-edit">
        {userDisplay}
        <div>
            {mainContent}
        </div>
    </div>
}

export function UserProfileView() {
    return <UserProfile />
}